import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import store from './store/session';
import allCom from './components/ctrl/index'
import {get, post,postImage, postBase, put} from './util/http'    //封装http请求




const app=createApp(App)


app.config.globalProperties.API_URL = window.location.origin + '/api';
//app.config.globalProperties.API_URL= 'https://api.wgdazi.cn';    

app.config.globalProperties.$get = get;
app.config.globalProperties.$post = post;
app.config.globalProperties.$postImage = postImage;
app.config.globalProperties.$postBase = postBase;
app.config.globalProperties.$put = put;
app.config.globalProperties.$store = store;
app.config.globalProperties.$router = router;
app.config.globalProperties.$gdKey = '90a98fae2dfe4e2a8e84053de7660410'


for(const [key,component]of Object.entries(ElementPlusIconsVue)){
    app.component(key,component)
}
app.use(allCom)
app.use(store)
app.use(router)
app.use(ElementPlus,{
    locale:zhCn,
})
app.mount('#app')

